if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getColumnLocalization() {
        const hostname = window.location.hostname.toLowerCase();

        const shopifyLocale =
          window.Shopify && Shopify.locale
            ? Shopify.locale
            : '';

        const rawLocale = (
          document.documentElement.lang ||
          shopifyLocale ||
          'es'
        ).toLowerCase();

        let language = rawLocale.split('-')[0];

        if (hostname.endsWith('.pt')) {
          language = 'pt';
        } else if (
          hostname.endsWith('.fr') ||
          hostname.endsWith('.lu')
        ) {
          language = 'fr';
        } else if (hostname.endsWith('.it')) {
          language = 'it';
        } else if (hostname.endsWith('.se')) {
          language = 'sv';
        } else if (hostname.endsWith('.pl')) {
          language = 'pl';
        } else if (
          hostname.endsWith('.de') ||
          hostname.endsWith('.at')
        ) {
          language = 'de';
        } else if (hostname.endsWith('.ro')) {
          language = 'ro';
        } else if (hostname.endsWith('.nl')) {
          language = 'nl';
        } else if (hostname.endsWith('.cz')) {
          language = 'cs';
        } else if (hostname.endsWith('.hu')) {
          language = 'hu';
        } else if (hostname.endsWith('.dk')) {
          language = 'da';
        } else if (hostname.endsWith('.fi')) {
          language = 'fi';
        } else if (hostname.endsWith('.ee')) {
          language = 'et';
        } else if (hostname.endsWith('.lv')) {
          language = 'lv';
        } else if (hostname.endsWith('.lt')) {
          language = 'lt';
        } else if (hostname.endsWith('.gr')) {
          language = 'el';
        } else if (hostname.endsWith('.co.uk')) {
          language = 'en';
        } else if (hostname.endsWith('.ad')) {
          language = 'ca';
        } else if (hostname.endsWith('.be')) {
          language = language === 'nl' ? 'nl' : 'fr';
        } else if (hostname.endsWith('.ch')) {
          if (language !== 'fr' && language !== 'it') {
            language = 'de';
          }
        } else if (hostname.endsWith('.es')) {
          language = 'es';
        }

        const translations = {
          es: {
            propertyKey: 'Columna auxiliar',
            fallback: 'Columna auxiliar FLORENCIA',
          },

          pt: {
            propertyKey: 'Coluna auxiliar',
            fallback: 'Coluna auxiliar FLORENCIA',
          },

          fr: {
            propertyKey: 'Colonne auxiliaire',
            fallback: 'Colonne auxiliaire FLORENCIA',
          },

          it: {
            propertyKey: 'Colonna ausiliaria',
            fallback: 'Colonna ausiliaria FLORENCIA',
          },

          de: {
            propertyKey: 'Zusatzschrank',
            fallback: 'Zusatzschrank FLORENCIA',
          },

          pl: {
            propertyKey: 'Dodatkowy słupek',
            fallback: 'Dodatkowy słupek FLORENCIA',
          },

          ro: {
            propertyKey: 'Coloană auxiliară',
            fallback: 'Coloană auxiliară FLORENCIA',
          },

          nl: {
            propertyKey: 'Extra kolomkast',
            fallback: 'Extra kolomkast FLORENCIA',
          },

          sv: {
            propertyKey: 'Extra högskåp',
            fallback: 'Extra högskåp FLORENCIA',
          },

          cs: {
            propertyKey: 'Doplňková skříňka',
            fallback: 'Doplňková skříňka FLORENCIA',
          },

          hu: {
            propertyKey: 'Kiegészítő oszlop',
            fallback: 'Kiegészítő oszlop FLORENCIA',
          },

          da: {
            propertyKey: 'Ekstra højskab',
            fallback: 'Ekstra højskab FLORENCIA',
          },

          fi: {
            propertyKey: 'Lisäkaappi',
            fallback: 'Lisäkaappi FLORENCIA',
          },

          et: {
            propertyKey: 'Lisakapp',
            fallback: 'FLORENCIA lisakapp',
          },

          lv: {
            propertyKey: 'Papildu skapis',
            fallback: 'FLORENCIA papildu skapis',
          },

          lt: {
            propertyKey: 'Papildoma spintelė',
            fallback: 'FLORENCIA papildoma spintelė',
          },

          el: {
            propertyKey: 'Βοηθητική στήλη',
            fallback: 'Βοηθητική στήλη FLORENCIA',
          },

          en: {
            propertyKey: 'Auxiliary cabinet',
            fallback: 'FLORENCIA auxiliary cabinet',
          },

          ca: {
            propertyKey: 'Columna auxiliar',
            fallback: 'Columna auxiliar FLORENCIA',
          },
        };

        return translations[language] || translations.es;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const loadingSpinner =
          this.querySelector('.loading__spinner');

        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const quickAddModal =
          this.closest('quick-add-modal');

        const columnSelect =
          quickAddModal?.querySelector(
            '[data-ob-quick-column]'
          );

        const columnVariantId =
          columnSelect?.value;

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        /*
         * =========================================================
         * COLUMNA AUXILIAR DESDE QUICK ADD
         * =========================================================
         */

        if (columnVariantId) {
          const columnCopy =
            this.getColumnLocalization();

          /*
           * El valor ya viene traducido desde quick-add.js.
           * Este fallback únicamente se utiliza si por algún motivo
           * no existe data-label en la opción seleccionada.
           */
          const columnLabel =
            columnSelect
              .selectedOptions[0]
              ?.dataset.label ||
            columnCopy.fallback;

          const quantity = Number(
            formData.get('quantity') || 1
          );

          const productProperties = {};

          /*
           * Conservamos cualquier propiedad que ya tenga
           * el producto principal.
           */
          formData.forEach((value, key) => {
            const propertyMatch =
              key.match(
                /^properties\[(.+)\]$/
              );

            if (
              propertyMatch &&
              value
            ) {
              productProperties[
                propertyMatch[1]
              ] = value;
            }
          });

          /*
           * IMPORTANTE:
           * El nombre que se ve en carrito queda traducido
           * al idioma correspondiente.
           */
          productProperties[
            columnCopy.propertyKey
          ] = columnLabel;

          const productItem = {
            id: String(
              formData.get('id')
            ),
            quantity,
            properties:
              productProperties,
          };

          const sellingPlan =
            formData.get(
              'selling_plan'
            );

          if (sellingPlan) {
            productItem.selling_plan =
              sellingPlan;
          }

          const requestBody = {
            items: [
              productItem,

              /*
               * Segunda línea:
               * columna auxiliar real.
               */
              {
                id: String(
                  columnVariantId
                ),

                quantity,

                /*
                 * Esta propiedad empieza por "_"
                 * y Shopify no la muestra al cliente.
                 *
                 * Se mantiene como identificador interno
                 * para no alterar ninguna automatización
                 * u operativa existente.
                 */
                properties: {
                  _Complemento:
                    'Columna auxiliar FLORENCIA',
                },
              },
            ],
          };

          if (this.cart) {
            requestBody.sections =
              this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                );

            requestBody.sections_url =
              window.location.pathname;
          }

          config.headers[
            'Content-Type'
          ] = 'application/json';

          config.body =
            JSON.stringify(
              requestBody
            );
        } else {
          config.body = formData;
        }

        /*
         * =========================================================
         * AÑADIR AL CARRITO
         * =========================================================
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )
          .then((response) =>
            response.json()
          )
          .then((response) => {
            if (response.status) {
              window.dataLayer =
                window.dataLayer || [];

              window.dataLayer.push({
                event:
                  'ob_cart_error',

                variant_id:
                  formData.get('id'),

                message:
                  response.errors ||
                  response.description ||
                  response.message,
              });

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source:
                    'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            } else if (!this.cart) {
              window.location =
                window.routes.cart_url;

              return;
            }

            window.dataLayer =
              window.dataLayer || [];

            window.dataLayer.push({
              event:
                'ob_add_to_cart_success',

              variant_id:
                formData.get('id'),

              quantity: Number(
                formData.get(
                  'quantity'
                ) || 1
              ),
            });

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source:
                    'product-form',

                  productVariantId:
                    formData.get('id'),

                  cartData:
                    response,
                }
              ).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(
                          response
                        );
                      }
                    );
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(
                    response
                  );
                }
              );
            }
          })
          .catch((e) => {
            console.error(e);

            window.dataLayer =
              window.dataLayer || [];

            window.dataLayer.push({
              event:
                'ob_cart_error',
              type: 'network',
              message: e.message,
            });
          })
          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            const loadingSpinner =
              this.querySelector(
                '.loading__spinner'
              );

            if (loadingSpinner) {
              loadingSpinner.classList.add(
                'hidden'
              );
            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}